<template>
    <v-card flat style="min-height:20vh;overflow-x:scroll;box-shadow: 0px 0px 44px rgba(0, 0, 0, 0.04);border-radius: 10px;">
        <v-card-title class="subheading"><strong>Inventory by Season/SBU</strong>
        <v-spacer/>
       <v-btn-toggle  v-model="inventory_type">
              <v-btn :class="inventory_type=='ats' ? 'indigo white--text' : '' " small flat value="ats">
                ATS
              </v-btn>
              <v-btn small flat value="stock" :class="inventory_type=='stock' ? 'indigo white--text' : '' ">
                Stock
              </v-btn>
            </v-btn-toggle>
            &nbsp;
            &nbsp;
            
            <v-btn-toggle v-model="display_dollar">
              <v-btn :class="display_dollar=='qty' ? 'indigo white--text' : ''" small flat value="qty">
                Qty
              </v-btn>
             
              <v-btn :class="display_dollar=='cost' ? 'indigo white--text' : ''"  v-if="user_type!='S'" small flat value="cost">
                Cost
              </v-btn>
            </v-btn-toggle>
            <v-spacer/> 
            
        </v-card-title>
        <hr>
            <v-card-text style="min-height:850px;padding:0px;margin:0px;zoom:90%">
            <v-container v-if="loading" class="text-xs-center" justify-center >
                 <v-progress-circular
                 class="text-xs-center"
                    v-if="loading"
                    :size="100"
                    :width="5"
                    color="green dark"
                    valvue="Loading"
                    indeterminate
                    ></v-progress-circular>

            </v-container>
            <div id="atsInventorySeason"></div>    
        </v-card-text>
    </v-card>
    
</template>
<script>
//import SalesAnalysisModel from '../../api/service/SalesAnalysisService.js'
import DashboardService from '@/api/service/DashboardService.js'
import ApexCharts from 'apexcharts'

export default {
      components: {
           ApexCharts
      },
      data () {
          return {
              user_type:"S",
              options:{},
              dataset: [],
              legends:[],
              seriesData:[],
              loading:false,
              options:{},
              display_dollar:"qty",
              inventory_type:"ats",
              title:""
          }
      },
      created()  {
      },
      mounted() {
             var $localStorage =JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE))
         this.user_type = $localStorage.data.User.user_type
      
          this.refreshData()
      },
      methods: {
        refreshData() {
            this.loading=true
            DashboardService.getInventorybySeason()
                .then($styles => {
                    var $legends=[]
                    var $series=[]
                    var $keyStores= {}
                    var $legendData={}
                    var $data3 = $styles.data;
                     if(this.display_dollar=='cost') {
                        this.title = this.inventory_type=='stock' ?  'Stock Cost': 'ATS Cost'
                    } else if(this.display_dollar=='qty') {
                        this.title = this.inventory_type=='stock' ?  'Stock': 'ATS'
                    }    
                    for(var $i=0;$i<$data3.length;$i++) {
                        if (this.legends.indexOf($data3[$i].name)<0) {
                            this.legends.push($data3[$i].name)
                        }
                        if ($legends.indexOf($data3[$i].season_desc)<0) {
                            $legends.push($data3[$i].season_desc)
                        }  
                        if ($legends.indexOf($data3[$i].name)<0) {
                            $keyStores[$data3[$i].name]=0
                        }
                    }
                    for(var $i=0;$i<$legends.length;$i++) {
                        $legendData[$legends[$i]]=Object.assign({},$keyStores)
                    }
                    
                    for(var $i=0;$i<$data3.length;$i++) {
                        var $json = ($legendData[$data3[$i].season_desc])
                          if(this.display_dollar=='cost') {
                               $json[$data3[$i].name] = this.inventory_type=='stock' ?  $data3[$i].qty_on_hand_cost : $data3[$i].ats_cost
                        } else if(this.display_dollar=='qty') {
                             $json[$data3[$i].name] = this.inventory_type=='stock' ?  $data3[$i].qty_on_hand :  $data3[$i].ats
                        }
                        
                    
                    }
                    var $keys = Object.keys($legendData)
                    for(var $j=0;$j<$keys.length;$j++) {
                        var $json = {
                            name:$keys[$j],
                            data: []
                        }
                        var $json2 = Object.assign($legendData[$keys[$j]])

                        var $keys2 = Object.keys($legendData[$keys[$j]])
                        for(var $k=0;$k<$keys2.length;$k++) {
                            $json.data.push($json2[$keys2[$k]])
                        }
                        this.seriesData.push($json)
                    }
                    this.setChartOptions()  
                })
                //this.setChartOptions()
        },
        setChartOptions($series) {
            this.options = {
                chart: {
                    height: 550,
                    type: 'bar',
                    stacked: true,
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        barHeight:'80%'
                    },
                    
                },
                grid: {
                    xaxis: {
                        showLines: false
                    }
                },
                stroke: {
                    width: 1,
                    colors: ['#fff']
                },
                series: this.seriesData,
                title: {
                    text: ''
                },
                xaxis: {
                    min:-100,
                    title: {
                        "text":this.title,
                        style: {
                            color: '#d234adf',
                            fontSize: '12px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            cssClass: 'subheading',
                        },
                    },
                    categories: this.legends,
                    labels: {
                        formatter: function(val) {
                            return val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
                        }
                    }
                },
                yaxis: {
                    title: {
                        text: "By Sbu"
                    },
                    
                },
                tooltip: {
                    y: {
                        formatter: function(val) {
                        return val + "K"
                    }
                    }
                },
                fill: {
                    opacity: 1
                    
                },
                
                legend: {
                    position: 'top',
                    horizontalAlign: 'left',
                    offsetX: 40
                }
            }

                var chart = new ApexCharts(
                    document.querySelector("#atsInventorySeason"),
                    this.options
                );
                this.loading=false
                chart.render()
        },
        refreshData2() {
             DashboardService.getInventorybySeason()
                .then($styles => {
                     var $series = {}

                    if($styles.data[0].data.rows.length<=20) {
                        var $count = $styles.data[0].data.rows.length
                    } else {
                        var $count=$styles.data[0].data.rows.length
                    }
                    for(var $i=0;$i<$count;$i++) {
                       // this.dataset.push({value:$styles.data[0].data.rows[$i].QTY_ON_HAND,
                        //name:$styles.data[0].data.rows[$i].NAME})
                        this.dataset.push(
                        {
                            name: $styles.data[0].data.rows[$i].NAME,
                            type: 'bar',
                            stack: 'SEASON_DESC',
                            stacked:true,   
                            label: {
                                normal: {
                                    show: false,
                                    position: 'insideRight'
                                }
                            },
                             data: [1,2,3,4,5   ]
                        })
                        if (this.legends.indexOf($styles.data[0].data.rows[$i].SEASON_DESC)<0) {
                            this.legends.push($styles.data[0].data.rows[$i].SEASON_DESC)
                        }
                       
                        if($series[$styles.data[0].data.rows[$i].NAME]) {
                            $series[$styles.data[0].data.rows[$i].NAME].data.push($styles.data[0].data.rows[$i].ATS)
                        } else {
                            $series[$styles.data[0].data.rows[$i].NAME]={
                                name: $styles.data[0].data.rows[$i].NAME,
                                type: 'bar',
                                stack: 'Inventory',
                                label: {
                                    normal: {
                                    show: false,
                                    position: 'insideRight'
                                    }
                                },
                                data:[]
                            }
                            $series[$styles.data[0].data.rows[$i].NAME].data.push($styles.data[0].data.rows[$i].ATS)
                        }
                        
                    }
                    var $keys = Object.keys($series)
                    //alert(JSON.stringify($keys))
                    for(var $j=0;$j<$keys.length;$j++) {
                        this.seriesData.push($series[$keys[$j]])
                    }
                    this.setInventory()
                    this.$forceUpdate()
            })
          },
          setInventory($sales) {
             this.setChart() 
             this.loading=true 
          }
  }
}
</script>
<style scoped>
.echarts {
  width: 100%;
  height: 100%;
}
</style>